import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux'
import { Link } from "react-router-dom"
import classNames from 'classnames';
import ReactLoading from 'react-loading';

import agent from '../agent'
import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';

import Back from '../components/Back'
import AMLogo from '../assets/images/audition-magic-favicon.png'

import Modal from 'react-responsive-modal';

import ethnicities from '../data/ethnicities';

import Roles from '../components/Roles'
import Statistics from '../components/Statistics'
import Questions from '../components/Questions'
import Availability from '../components/Availability'
import Scheduling from '../components/Scheduling'
import Media from '../components/Media'
import Confirmation from '../components/Confirmation'
import ImDb from '../components/ImDb';


const Header = ({clientDetails, artistInfo, fromRegistration}) => 
	<section id="brand-logo" className="section-brand-logo dashboard-header section">
	  <div className="row">
	  <div className="small-12 small-centered column text-center">
	  	<img className="company-logo" src={clientDetails.logo_url || AMLogo} alt=""/>
	  	<div className="post-relative with-name">
	  		<Back />
	  		<h2>Welcome { !fromRegistration && "Back" } {artistInfo.first_name}</h2>
		    <p className="top-title">Please follow the steps below to submit yourself</p>
	    </div>
	  </div>
	  </div>
	</section>

const ErrorMessage = ({message, flag, token}) => {
	// const url = 'https://casting.auditionmagic.com/ForgotPassword.aspx'
	const url = '/forgotpassword' //forgotpassword
	
	if (flag) {
		return (<div className="margin-bottom-here">You are unable to create a profile with this email and contact information, because a User already exists in the system with the same information, please
				<b><Link to={{
						 pathname: 'artist/login',
						 search: '?token=' + token
					}}>&nbsp;Login</Link></b> or 
				<b><a href={url} target="_blank">
					&nbsp;click here if you forgot your password</a></b>
			</div>)
	} else {
		return (<div className="margin-bottom-here">{ message }</div>)
	}
}

class Apply extends Component {
	steps = ['roles', 'statistics', 'questions', 'availability', 'scheduling', 'media', 'confirmation'] //media
	state = {
		wizardSteps: this.steps,
		currentPage: 'roles',
		exceptedpage: ['roles', 'confirmation'],	//first and last steps
		dummypage: 'roles',
		selected_roles: [],	//second steps
		enableButton: false,
		loading: false,
		showModal: false,
		errorMessage: '',
		project: {},
		availability_questions: [],
		job_questions: [],
		clientDetails: {},
		roleList: [],
		filesList: [],
	}	//'scheduling'

	componentWillMount() {
		// console.log('P',this.props)
		// console.log('S',this.state)
		let in_project = null
		if (this.props.location.state.projectDetails) {
			in_project = this.props.location.state.projectDetails.project
			this.setState( { project: in_project, loading: true })
		}
		else {
			in_project = this.props.location.state.clientDetails.projectId
			this.setState( { project: in_project, loading: true })
		}
		this.props.clearCheckin()
		this.props.getRooms(in_project)
		
	}


	async componentDidMount() {
		let in_project = null
		let job_questions = []
		let availability_questions = []
		if (this.props.location.state.projectDetails) {
			in_project = this.props.location.state.projectDetails

			let roles = this.props.location.state.roleList;

			if (roles == null || roles.length == 0) {
				roles = in_project.roles;
			}

			if (roles == null || roles.length == 0) {
				roles = await agent.Project.getRoles(in_project.project.id)
			}

			job_questions = in_project.job_questions
			availability_questions = in_project.availability_questions

			this.setState({
				availability_questions: in_project.availability_questions,
				job_questions: in_project.job_questions,
				clientDetails: this.props.location.state.clientDetails,
				roleList: roles,
				loading: false })
		}
		else {
			in_project = this.props.location.state.clientDetails.projectId
			const value = await agent.Client.getRegQuestions(in_project.id)
			const client = await agent.Agency.companyDetails(in_project.company_id)
			const roles = await agent.Project.getRoles(in_project.id)

			job_questions = value.questions.job
			availability_questions = value.questions.availability

			console.log('roles-reveal', value);

			this.setState({ 
				availability_questions: value.questions.availability,
				job_questions: value.questions.job,
				clientDetails: client.company,
				roleList: roles.roles })

			this.setState({ loading: false })
		}

		in_project = this.state.project
		

		let wizSteps = this.state.wizardSteps.filter(function(currentStep, index, arr){
			if (currentStep === 'media') return in_project.public_upload;
			if (currentStep === 'questions') return (in_project.public_questions_enabled && job_questions.length > 0);
			if (currentStep === 'availability') return 	(in_project.public_questions_enabled && availability_questions.length > 0);
			if (currentStep === 'scheduling') return in_project.public_scheduling_enabled;
			if (currentStep === 'statistics') return in_project.public_stats_enabled;
			return true;
		});

		this.setState({wizardSteps: wizSteps});
	}

	handleSave = (values) => {
		try {
			//=============== same as onSubmit ===============
	  	const { location } = this.props
			const publicToken = new URLSearchParams(location.search).get('token')
			const imdb = new URLSearchParams(this.props.location.search).get('imdb')
			
			const artist_payload = this.setParameters(location, publicToken, values, imdb)

			this.setState({selected_roles: values.roles});
			window.localStorage.setItem('role_ids', values.roles.join(','));

			let that = this
			agent.Artist.saveCurrentCheckin(artist_payload).then((res) => {
				console.log('submit-save', res)

				if (res.auditions != null && res.auditions.length > 0 && res.auditions[0].pubreg_data){
					if (window.localStorage.getItem('q_jwt'))
						window.localStorage.removeItem('q_jwt')

					let qs = res.auditions[0].pubreg_data.questions_answers
					window.localStorage.setItem('q_jwt', qs)
				}

				window.localStorage.removeItem('artist_jwt')
	      window.localStorage.setItem('artist_jwt', JSON.stringify(res))
	    })
	  	//=============== same as onSubmit ===============
	  } catch (error) {
	  	window.appsignal.sendError(error);
	  }
	}

	nextPage = async values => {
  	const { wizardSteps, currentPage } = this.state

  	let nextPage = wizardSteps[wizardSteps.indexOf(currentPage) + 1]
  	
  	if (nextPage == 'media') {
			// Pull in the media needed
			let roles = this.state.selected_roles.join(',')
			let project_id = this.state.project.id
			let artist_id = this.props.location.state.artist.id
			let files = await agent.Project.mediaForArtist(project_id, artist_id, roles)

			this.setState({filesList: files.media})
		}

		this.setState({
			currentPage: nextPage,
			dummypage: wizardSteps.indexOf(currentPage) >= 1 ? '--' : 'statistics'
		})
	}

	previousPage = async values => {
		const { wizardSteps, currentPage } = this.state

		let nextPage = wizardSteps[wizardSteps.indexOf(currentPage) - 1]
  	
  	if (nextPage == 'media') {
			// Pull in the media needed
			let roles = this.state.selected_roles.join(',')
			let project_id = this.state.project.id
			let artist_id = this.props.location.state.artist.id
			let files = await agent.Project.mediaForArtist(project_id, artist_id, roles)

			this.setState({filesList: files.media})
		}

		this.setState({
			currentPage: nextPage,
			dummypage: wizardSteps.indexOf(currentPage) >= 1 ? '--' : 'statistics'
		})
	}

	setParameters = (location, publicToken, values, imdb) => {
		const toUnderscore = name => {
			return name.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});
		};

		let artist_payload = {
			project_id: location.state.clientDetails.projectId.id,
			artist_id: location.state.artist.id,
			signature_image: values.signature || '',
			statistics_region: values.statistics_region,
			measurement_sizing: values.measurement_sizing,
			statistics_unit: values.statistics_unit,
		}

		if (publicToken){
			artist_payload.public_registration = true,
			artist_payload.imdb_ident = imdb
		}

		if (values.roles && values.roles.length) {
				artist_payload.roles = values.roles
		}

		let statistics = {};

		let questions_answers = {
			job: [],
			availability: []
		};

		for (let [key] of Object.entries(values)) {
			if (key === 'availability' || key === 'questions') {
				for (let [key_1, val_1] of Object.entries(values[key])) {
				  	const k = key_1.replace('_', '');
				  	let obj = {};
				  	obj.question_id = k;
				  	obj.answer = val_1;

				  	if (key === 'questions') {
				  		questions_answers.job.push(obj);
				  	}

				  	if (key === 'availability') {
				  		questions_answers.availability.push(obj);
				  	}
				}
			}


			if (key === 'statistics') {
				for (let [key_2, val_2] of Object.entries(values[key])) {
				  	const k = toUnderscore(key_2);

				  	if (k === 'ethnicities') {
							val_2 = val_2.map(item => item.id)
							val_2 = val_2.join(',')
						}

				    statistics[k] = val_2;
				}
			}
		}

		artist_payload.stats_region = 'US';
		artist_payload.statistics = JSON.stringify(statistics);
		console.log('apply-statistics', artist_payload.statistics, statistics)
		artist_payload.questions_answers = JSON.stringify(questions_answers)
		artist_payload.wizard_stage = this.state.currentPage

		return artist_payload
	}

	submit = async values => {
		const { location } = this.props
		const publicToken = new URLSearchParams(location.search).get('token')
		const imdb = new URLSearchParams(this.props.location.search).get('imdb')
		//this.setState({ loading: true })
		///set parameters was here
		const artist_payload = this.setParameters(location, publicToken, values, imdb)

		window.localStorage.removeItem('role_ids')

		let that = this
		this.props.submitPublicRegistration(artist_payload).then((res) => {
			console.log('submit-apply', that.props)
			that.setState({ enableButton: true })
			window.localStorage.removeItem('artist_jwt')
      window.localStorage.setItem('artist_jwt', JSON.stringify(that.props.artist))
      if (that.props.meta) {
      	window.localStorage.setItem('user_jwt', JSON.stringify(that.props.meta))
      }
		})
	}
	
	logout = () => {
		window.localStorage.removeItem('artist_jwt');
		if (this.props.logoutAritst)
			this.props.logoutAritst();
		else {
			window.location.pathname = 'public_registration'
		}
	}

	backToDashboard = () => {
		this.props.clearCheckin();
	}

	onOpenModal = () => {
    this.setState({ showModal: true });
  }
	  
	onCloseModal = () => {
	    this.setState({ showModal: false });
	    history.push({
	      pathname: '/artist/login',
	      search: this.props.location.search,
	      state: this.props.location.state
	    })
	}

	render() {
		const { currentPage, exceptedpage, dummypage, loading, job_questions, project, availability_questions, roleList } = this.state
		const { location, errors, auditions, checkinSuccess, checkin, fromRegistration, roles, success, available_rooms } = this.props
		const { projectDetails } = location.state
		const publicToken = new URLSearchParams(location.search).get('token')
		const imdb = new URLSearchParams(this.props.location.search).get('imdb')
		const type = { name: "spin" }

		console.log('render-apply', location)
		// let idx = wizardSteps.indexOf('media')
		// if (!projectDetails.project.public_artist_upload_required)
		// 	wizardSteps.splice(idx,1)
		let in_proj = project
		let artistInfo = this.props.artistInfo

		let clientDetails = location.state
		let wizardSteps = this.state.wizardSteps

		if (clientDetails == null || clientDetails.logo_url == null) {
			clientDetails = this.state.clientDetails.client
		}

		if (clientDetails == null || clientDetails.logo_url == null) {
			clientDetails = this.state.clientDetails
		}

		try {
			if (artistInfo == null) {
				let artist_storage = JSON.parse(window.localStorage.getItem('artist_jwt'))
	    	artistInfo = artist_storage ? artist_storage.artist : this.state.artistInfo
			}
		} catch (error) {
			window.appsignal.sendError(error)
		}

		if (artistInfo == null) {
			this.logout();
		}
		
		if (loading) {
			return (
				<div className="checkin-success">
				<Header {...this.props.location.state} checkin={checkin} artistInfo={this.props.artistInfo} clientDetails={clientDetails} success="true"/>

				<section className="section gray-bg">
					<div className="grid-x align-center">
					<div className="small-12 medium-10 large-8 cell">

					<div className="text-center white-text">
						<h3>Loading details...</h3>
						<h5 className="loading-text">Please wait until all details have been loaded.</h5>
						<p></p>
					</div>

					</div>
					</div>
				</section>
				</div>)
		} 

		if (checkinSuccess) {
			return (
				<div className="checkin-success">
				{ imdb && (<ImDb />) }
				<Header {...this.props.location.state} checkin={checkin} artistInfo={this.props.artistInfo} clientDetails={clientDetails} success="true"/>

				<section className="section gray-bg">
					<div className="grid-x align-center">
					<div className="small-12 medium-10 large-8 cell">

					<div className="text-center white-text">
						<h3>Success!</h3>
						<h5 className="loading-text">THANK YOU FOR YOUR APPLICATION</h5>
						<p>You have successfully applied for this project and submitted your auditions, should you be successful, you will be contacted by the project owners via the phone and/or email details you listed in your registration. Goodluck!</p>
					</div>

					</div>
					</div>
				</section>

				<section className="section">
					<div className="grid-x align-center">
						<div className="medium-6 cell text-center">
							{
								this.state.clientDetails
									? <Link className="button primary"
											to={{
												pathname: '/artist/dashboard/projects',
												state: { ...location.state, flag: true, clientDetails: this.state.clientDetails, checkinSuccess: false }
											}} 
											>
											Please click here
										</Link>
									: <Link className="button primary next" 
											onClick={this.logout}>Login to your Profile Now
										</Link>
							}
						</div>
					</div>
				</section>
				</div>
			)
		}

		return (
			<div className="public-registration-container">
				<Modal classNames={{ modal: 'small-modal' }} open={this.state.showModal} onClose={this.onCloseModal} little>
		          <h2 className="reveal-title">Error occured</h2> 
		          
		          <ErrorMessage message={this.state.errorMessage} flag={this.state.errorMessage === 'Loginname duplicated'} token={publicToken} />
		          
		          <div className="clearfix"></div>
		          <button className="button float-left" onClick={this.onCloseModal}>Close</button>
		    	</Modal>
		    	{ imdb && (<ImDb />) }
				<Header {...location.state} artistInfo={artistInfo} fromRegistration={fromRegistration} clientDetails={clientDetails} />

				<section className="section gray-bg">
					<div className="row">
						<div className="small-12 small-centered column text-center">
							<img src={this.state.project.cover_url} alt="" width="267"/>
						</div>
					</div>
				</section>

				
				<section id="artist-essentials" className="section-artist-essentials gray-bg">
					<div className="grid-x align-center text-center">
						<div className="small cell small-10 medium-10 large-8 cell">
							<ul className="tabs menu steps expanded" data-tabs>
							{
								wizardSteps.map((currentStep, index) => 
									{
										console.log('wizardSteps-map', currentStep, index)
										return (<li key={index + 1} className={
												classNames("tabs-title", {'columnli':  true}, {'firstend-columnli': wizardSteps.indexOf(currentPage) == (wizardSteps.length - 1)},
													{'hideli' : (wizardSteps.indexOf(currentStep) !== wizardSteps.indexOf(currentPage)) && exceptedpage.indexOf(currentStep) === -1}, 
													{'showli' : (wizardSteps.indexOf(currentStep) === wizardSteps.indexOf(currentPage)) || (currentStep === dummypage && currentStep !== currentPage)}, 
													{'is-active' : wizardSteps.indexOf(currentStep) <= wizardSteps.indexOf(currentPage) })}>
										  	<div className="step-num">{index + 1}</div>
									        <div className="step-name">{currentStep}</div>
									  </li>)
									}
								)
							}
							</ul>
						</div>
					</div>
				</section>
				<div id="public-registration-wizard">
				<div>
					<ReactLoading style={{margin: '21px', width: '100px', display: this.state.loading ? 'block' : 'none'}} type={type.name} color="#000" />
				</div>
					{(() => {

						const wizardButtons = {
							nextPage: wizardSteps.indexOf(currentPage) !== wizardSteps.length - 1 ? true : false,
						  previousPage: wizardSteps.indexOf(currentPage) !== 0 && this.previousPage,
						  onSubmit: wizardSteps.indexOf(currentPage) === wizardSteps.length - 1 ? this.submit : this.nextPage
						}

						switch(currentPage) {
							case 'roles':
								return <Roles roles={this.state.roleList}
										publicToken={publicToken}
										location={location}
										project={this.state.project}								
			      		  	artist={this.props.artistInfo || this.props.location.state.artist }
			      		  	handleSave={this.handleSave}
			      			{...wizardButtons} />
							case 'statistics':
								return <Statistics 
							      		artist={this.props.artistInfo || this.props.location.state.artist }
							      		handleSave={this.handleSave}
							      		{...wizardButtons} />
							case 'questions':
								return <Questions
		          					questions={this.state.job_questions}
		          					handleSave={this.handleSave}
		            				{...wizardButtons} />
							case 'availability':
								return <Availability
		          					availability={availability_questions}
		          					handleSave={this.handleSave}
		            				{...wizardButtons} />
	        		case 'scheduling':
								return <Scheduling
		          					projectDetails={project}
		          					roles={roleList}
		          					available_rooms={available_rooms}
		          					selected_audition_event={this.props.selected_audition_event}
		          					handleSave={this.handleSave}
		            				{...wizardButtons} />
	        		case 'media':
								return <Media
		          					media="test"
		          					publicArtist={location.state.publicArtist}
		          					project={this.state.project}
		          					filesList={this.state.filesList}
		          					handleSave={this.handleSave}
		            				{...wizardButtons} />
							case 'confirmation':
								return <Confirmation
									errors={errors}
									projectDetails={project}
									clientDetails={this.state.clientDetails}
									currentState={this.props.location.state}
									location={location}
									artist={this.props.artistInfo || this.props.location.state.artist }
									setSignature={this.props.setSignature}
									flag={this.state.project.public_signature_enabled}
									flagterms={this.state.project.public_terms_enabled}
									enableButton={this.state.enableButton}
			            {...wizardButtons} />
						}

					})()}
				</div>

			</div>

		)
	}
}

// const mapStateToProps = state => ({

// })

Apply = reduxForm({
  form: 'checkinWizard', // <------ same form name
  destroyOnUnmount: true, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate
})(Apply)

const mapStateToProps = (state, ownProps) => {

	const stats = state.common.artistInfo ? state.common.artistInfo.statistics : ownProps.location.state.artist.statistics
	const region = state.common.artistInfo ? state.common.artistInfo.country : 'US'

	const currentEthnicities = stats.ethnicities ? JSON.parse(`[${stats.ethnicities}]`) : []
	const parsedEthnicities = ethnicities.filter(item => currentEthnicities.includes(parseInt(item.id)) )


	if (stats.licenses_held) {
		delete stats.licenses_held
	}

	let qas = window.localStorage.getItem('q_jwt')
	try {
		qas = JSON.parse(qas)
	} catch (error) {}

	if (qas == null)
		qas = { 'job': [], 'availability' : [] }

	let job_qs = {}
	if (qas.job.length > 0)
		job_qs = Object.assign({}, ...qas.job.map((x) => ({['_' +x.question_id]: x.answer})));

	let avl_qs = {}
	if (qas.availability.length > 0)
		avl_qs = Object.assign({}, ...qas.availability.map((x) => ({['_' +x.question_id]: x.answer})));


	let aas = window.localStorage.getItem('artist_jwt')
	try {
		aas = JSON.parse(aas)
	} catch (error) {}


	if (aas == null || aas.roles == null)
		aas = { roles: [] }


	return ({
		...state.auth,
		...state.common,
		...state.artist,
		...state.client,
		...state.projects,
		checkin: state.artist.checkin,
		success: state.artist.success,
		available_rooms: state.projects.available_rooms ? state.projects.available_rooms.rooms : [],
		selected_audition_event: state.projects.available_rooms ? state.projects.available_rooms.meta : null,
		initialValues: {
			project_id: ownProps.location.state.clientDetails.projectId.id,
			artist_id: ownProps.location.state.artist.id,
			statistics_region: 'US',
			statistics_unit: 'IN',
			measurement_sizing: 'ADLT',
			questions: job_qs,
			availability: avl_qs,
			roles: aas.roles.map((currValue) => currValue.id),
	    statistics: {
	      // region: region,
	      ...stats,
	      ethnicities: parsedEthnicities
	    }
	  }
	})
}

const mapDispatchToProps = (dispatch) => ({
	setSignature: sig => dispatch(change( "checkinWizard", "signature", sig)),
	submitPublicRegistration: payload =>
		dispatch({ type: 'SUBMIT_CHECKIN', payload: agent.Artist.checkin(payload) }),
	logoutArtist: () =>
		dispatch({ type: 'LOGOUT' }),
	clearCheckin: () =>
		dispatch({ type: 'CLEAR_CHECKIN'}),
	getRooms: (data) => 
		dispatch({ type: 'GET_ROOMS', payload: agent.Project.getRooms(data) }),
})


export default connect(mapStateToProps, mapDispatchToProps)(Apply)


// WEBPACK FOOTER //
// ./src/containers/Apply.js